export class LanguageStorage {
    public static language: string = 'english';
}